// extracted by mini-css-extract-plugin
export var actionText = "_qu-4";
export var container = "_qu-0";
export var leftSection = "_qu-1";
export var rightSection = "_qu-2";
export var settingsButton = "_qu-6";
export var settingsIcon = "_qu-7";
export var shortcut = "_qu-5";
export var shortcutGroup = "_qu-3";